import { render } from "./ContactHealthScoreBadge.vue?vue&type=template&id=7b1c8730&ts=true"
import script from "./ContactHealthScoreBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactHealthScoreBadge.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/contact/components/ContactHealthScoreBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b1c8730"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b1c8730', __exports__)) {
    api.reload('7b1c8730', __exports__)
  }
  
  module.hot.accept("./ContactHealthScoreBadge.vue?vue&type=template&id=7b1c8730&ts=true", () => {
    api.rerender('7b1c8730', render)
  })

}


export default __exports__